var amdi18n={"__root":{"SEARCH_SETTINGS":"Search Settings","AUTO_JUMP_TO_NEXT":"Auto-advance after deletion","AUTO_JUMP_TO_NEXT_DESCRIPTION":"Automatically move to the next result after deleting content","PREVIEW_WITH_OPERATION":"Preview with changes","PREVIEW_WITH_OPERATION_DESCRIPTION":"Play result showing your changes (e.g., after deleting content)","PREVIEW_WITHOUT_OPERATION":"Preview original","PREVIEW_WITHOUT_OPERATION_DESCRIPTION":"Play result showing original content (before any changes)","PLAYBACK_SETTINGS":"Playback Settings"},"__fr":{"SEARCH_SETTINGS":"Paramètres de recherche","AUTO_JUMP_TO_NEXT":"Avancer automatiquement après suppression","AUTO_JUMP_TO_NEXT_DESCRIPTION":"Se déplacer automatiquement vers le résultat suivant après avoir supprimé du contenu","PREVIEW_WITH_OPERATION":"Aperçu avec modifications","PREVIEW_WITH_OPERATION_DESCRIPTION":"Lire le résultat avec vos modifications (ex: après suppression du contenu)","PREVIEW_WITHOUT_OPERATION":"Aperçu original","PREVIEW_WITHOUT_OPERATION_DESCRIPTION":"Lire le résultat sans modifications (contenu original)","PLAYBACK_SETTINGS":"Paramètres de lecture"},"__en":{"SEARCH_SETTINGS":"Search Settings","AUTO_JUMP_TO_NEXT":"Auto-advance after deletion","AUTO_JUMP_TO_NEXT_DESCRIPTION":"Automatically move to the next result after deleting content","PREVIEW_WITH_OPERATION":"Preview with changes","PREVIEW_WITH_OPERATION_DESCRIPTION":"Play result showing your changes (e.g., after deleting content)","PREVIEW_WITHOUT_OPERATION":"Preview original","PREVIEW_WITHOUT_OPERATION_DESCRIPTION":"Play result showing original content (before any changes)","PLAYBACK_SETTINGS":"Playback Settings"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;